import type {
  ActionTaskInput,
  CodeTaskInput,
  ConditionalInput,
  DataConnectorInput,
} from '@automata/wfb-api';
import {
  ConditionalSourceTaskInput,
  ContinuousLoadingInput,
} from '@automata/wfb-api/src/apis/wfbApiSchemas';

import type { ConditionalTaskProperties } from '../../../types';
import uuid from '../../../uuid';

type GetConditionalTaskProps = {
  taskId: string;
  taskProperties: ConditionalTaskProperties;
  ifTask:
    | ActionTaskInput
    | CodeTaskInput
    | DataConnectorInput
    | ConditionalInput
    | ContinuousLoadingInput
    | null;
  elseTask:
    | ActionTaskInput
    | CodeTaskInput
    | DataConnectorInput
    | ConditionalInput
    | ContinuousLoadingInput
    | null;
  sourceTask: string | ConditionalSourceTaskInput | null;
};

export const getConditionalTask = ({
  taskId,
  taskProperties,
  ifTask,
  elseTask,
  sourceTask,
}: GetConditionalTaskProps): ConditionalInput & {
  source_task?: string | ConditionalSourceTaskInput | null;
} => {
  return {
    tasks: ifTask && ifTask.id ? { [ifTask.id]: ifTask } : {},
    id: taskId,
    type: 'conditional',
    comparison: taskProperties.comparison,
    is_expected: taskProperties.expectedOutcome === 'IF condition',
    next: {
      tasks: elseTask && elseTask.id ? { [elseTask.id]: elseTask } : {},
      id: elseTask && elseTask.id ? elseTask.id : uuid(),
      type: 'conditional',
      comparison: 'Else',
      is_expected: taskProperties.expectedOutcome !== 'IF condition',
      next: null,
    },
    source_task: sourceTask,
  };
};
